import { useMutation, useQueryClient } from 'react-query'
import { PROFILE_QUERY_KEY } from '@entities/user'
import {
  retrySubscriptionIssue,
  type RetrySubscriptionIssueResponse,
} from '../api/subscriptionApi'

/**
 * Повторная выдача доступа в боте. После успеха перезапрашиваем профиль:
 * если выдача прошла, бэк снимет issue_canceled и предупреждение исчезнет.
 *
 * Ответ 200 со `status !== 'queued'` — отказ по условиям, а не ошибка запроса,
 * поэтому onError сюда не попадёт: статус разбирает вызывающий код.
 */
export const useRetrySubscriptionIssueMutation = () => {
  const qc = useQueryClient()
  return useMutation<RetrySubscriptionIssueResponse, Error, void>(
    retrySubscriptionIssue,
    {
      onSuccess: () => {
        qc.invalidateQueries(PROFILE_QUERY_KEY)
      },
    }
  )
}
